import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import type { ClassValue } from 'clsx'

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs))
}

export function buildQueryParams<T extends Record<string, any>>(params: T) {
  return Object.fromEntries(
    Object.entries(params).filter(([_, value]) => {
      if (value === '' || value === null || value === undefined) return false
      if (Array.isArray(value) && value.length === 0) return false
      if (typeof value === 'object' && Object.keys(value).length === 0)
        return false
      return true
    }),
  ) as Partial<T>
}
